<template>
    <div>
      <v-chip-group
        mandatory
        active-class="primary"
        @change="handleSelectLanguage"
      >
        <v-chip
          v-for="(languages) in listLanguage"
          small
          :key="languages.name"
          :value="languages"
        >
          {{ languages.name }}
        </v-chip>
      </v-chip-group>
      <div
        v-for="(language, index) in listLanguage"
        :key="index"
        v-show="selectedLanguage && language.guid === selectedLanguage.guid"
        class="pb-0 mb-0">
          <v-text-field
            v-if="type === 'textField'"
            :value="textValue[language.alternative]"
            :label="`${label} (${language.countryCode})`"
            :key="`${label}-${index}`"
            :hint="hint"
            :rules="rules[language.alternative]"
            @change="(e) => handlerInput(e, language)"
            persistent-hint
            :class="(language.alternative === 'alt1' && required) && 'required'"
            :ref="`inputValue${language.alternative}`"
          />
          <v-textarea
            v-if="type === 'textArea'"
            :value="textValue[language.alternative]"
            :label="`${label} (${language.countryCode})`"
            :key="`${label}-${index}`"
            :hint="hint"
            :rules="rules[language.alternative]"
            @change="(e) => handlerInput(e, language)"
            auto-grow
            rows="1"
            persistent-hint
            :class="(language.alternative === 'alt1' && required) && 'required'"
            :ref="`inputValue${language.alternative}`"
          />
      </div>
    </div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';

@Component
@MapGetters(['pointOfSaleLanguages'])
export default class DynameatLanguageFieldGenerator extends Vue {
  @Prop({ type: String, default: '' }) label;

  @Prop({ type: String, default: '' }) type;

  @Prop({ type: String, default: '' }) hint;

  @Prop({ Array, default: () => [] }) languages;

  @Prop({ type: Boolean, default: false }) required;

  @Prop({ type: Object, required: false }) rules;

  @Prop({ type: Object, required: true }) value;

  textValue = {};

  selectedLanguage = '';

  async created() {
    this.textValue = { ...this.value };
    // eslint-disable-next-line prefer-destructuring
    this.selectedLanguage = this.listLanguage[0];
  }

  @Watch('value')
  onValue(newValue) {
    if (newValue) {
      this.textValue = {};
      this.textValue = newValue;
    }
  }

  get listLanguage() {
    return this.languages.length > 0 ? this.languages : this.pointOfSaleLanguages;
  }

  handlerInput(value, language) {
    this.textValue[language.alternative] = value;
    this.$emit('input', this.textValue);
  }

  handleSelectLanguage(languages) {
    this.selectedLanguage = languages;
  }
}

</script>

<style>
.required label::after {
  content: " *";
  color: red;
}
</style>
